import React from 'react';
import ReactDOM from 'react-dom';
import LMSApp from './general/app.js';

var rootElement = document.getElementById('root');

ReactDOM.render(
    <LMSApp />, rootElement
);


// WEBPACK FOOTER //
// ./src/index.js